import React from 'react';
import '../css/StrategicObjectives.css';

const StrategicObjectives = () => {
  const objectivesList = [
    { id: 1, text: "Delivering practical and industry-oriented training" },
    { id: 2, text: "Supporting student career development" },
    { id: 3, text: "Promoting workplace health & safety awareness" },
    { id: 4, text: "Encouraging professional and ethical learning practices" },
    { id: 5, text: "Continuously improving training quality and learner support" },
    { id: 6, text: "Enhancing employability and practical skill development" }
  ];

  return (
    <section className="gfi-objectives-section">
      <div className="gfi-objectives-container">
        
        <div className="gfi-objectives-mesh-grid">
          
          {/* LEFT SIDE DATA COLUMN: HEADERS & COMMITMENT QUOTE STRIP */}
          <div className="gfi-obj-left-column">
            <span className="gfi-obj-upper-tag">GREENFIELD ACADEMY GOALS</span>
            <h2 className="gfi-obj-main-title">Our Strategic <br />Objectives</h2>
            <p className="gfi-obj-sub-paragraph">
              We are dedicated to maintaining the highest standards of safety education through these key organizational goals.
            </p>

            {/* Vertical Emerald Green Bar Accent Quote Box matching image 9_2 */}
            <div className="gfi-obj-commitment-quote-card">
              <p className="gfi-obj-quote-statement-txt">
                "We are committed to excellence in every training session we deliver."
              </p>
            </div>
          </div>

          {/* RIGHT SIDE DATA COLUMN: 2-COLUMN BALANCED MATRIX PILLS */}
          <div className="gfi-obj-right-column">
            <div className="gfi-obj-matrix-grid-framework">
              {objectivesList.map((obj) => (
                <div key={obj.id} className="gfi-obj-matrix-item-pill">
                  
                  {/* Soft Circular Mint Checkmark Circle Frame */}
                  <div className="gfi-obj-checkmark-circle-badge">
                    <span className="gfi-obj-check-icon">✓</span>
                  </div>

                  {/* Objective Statement Label */}
                  <p className="gfi-obj-statement-label-txt">{obj.text}</p>

                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default StrategicObjectives;